<template>
    <q-modal class="sl-modal users"
        :value="open"
        v-if="open"
        @hide="onClose()"
        id="details-modal"
        :no-esc-dismiss="true"
        :no-backdrop-dismiss="true"
        :maximized="maximized"
        :content-css="{width: '1200px', maxWidth: '100%', minHeight: '85vh'}"
    >
      <q-modal-layout>
        <q-toolbar slot="header">
          <q-toolbar-title >
            <q-icon name="fa fa-user"  />
            <span v-if="mode === 'add'">Add User</span>
            <span v-if="mode === 'edit'">Edit User Details {{editUserLabel}}</span>
            <span v-if="mode === 'approve'">Approve Instructor</span>
            <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
                class="label outline" 
                :class="{
                  'blue': this.activeApprovalStatus =='SUBMITTED' || this.activeApprovalStatus =='RESUBMITTED',
                  'green' : this.activeApprovalStatus =='APPROVED',
                  'red' : this.activeApprovalStatus =='REJECTED'
                }" 
                v-if="mode === 'approve' && this.activeApprovalHistory && this.activeApprovalHistory.length > 0">
                  {{ this.activeApprovalStatus }}
            </div>
            <div v-if="mode === 'approve' && this.activeApprovalStatus=='REJECTED' && this.activeApprovalNotes" style="display:inline-block">
                <q-icon name="help_outline" outlined color="negative" size="23px" style="margin-left:5px">
                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]">{{this.activeApprovalNotes}}</q-tooltip>                    
                </q-icon>
            </div>
          </q-toolbar-title>
          <q-btn-dropdown class="approval-history" icon="access time" v-if="mode === 'approve' && this.activeApprovalHistory && this.activeApprovalHistory.length > 0">
            <q-list v-for="(approval,i) in this.activeApprovalHistory" :key="i">
              <q-item v-close-overlay>
                <q-item-side :icon="approvalDetail(approval, true)" />
                <q-item-main>
                  <q-item-tile label>
                    {{approvalDetail(approval)}}
                  </q-item-tile>
                  <q-item-tile sublabel :title="moment(approval.DATE_CREATED).format('llll')">
                    {{moment(approval.DATE_CREATED).calendar()}}
                  </q-item-tile>
                </q-item-main>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <q-btn-dropdown icon="more vert" v-if="mode === 'edit' && currentUser().USER_ID != userForm.USER_ID">
              <q-list link>
                  <q-item @click.native="onRemove()" v-close-overlay :disable="savingUser">
                      <q-item-main>
                          <q-item-tile label><q-icon name="fa fa-trash" color="red" /> Delete User</q-item-tile>
                      </q-item-main>
                  </q-item>
              </q-list>
          </q-btn-dropdown>
          <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
          <q-icon @click.native="onClose" name="clear" />
        </q-toolbar>   
        <div class="sl-row sl-abs">
            <div class="sl-col-3 navigation sl-vp">
                <q-list highlight>
                    <q-item :class="{active:selectedTab === 'general'}" @click.native="updateSelectedTab('general')">
                        <q-item-main label="General" />
                        <q-item-side v-if="validation.userForm.$invalid" icon="fa fa-flag" color="red" class="flag-icon"/>
                    </q-item>
                    <q-item :class="{active:selectedTab === 'addresses'}" @click.native="updateSelectedTab('addresses')">
                        <q-item-main label="Addresses" />
                        <q-item-side v-if="validation.billingAddressForm.$invalid || validation.shippingAddressForm.$invalid" icon="fa fa-flag" color="red" class="flag-icon"/>
                    </q-item>
                    <q-item v-if="mode != 'add'" :class="{active:selectedTab === 'documents'}" @click.native="updateSelectedTab('documents')">
                        <q-item-main label="Documents" />
                    </q-item>
                    <q-item v-if="mode === 'edit'" :class="{active:selectedTab === 'security'}" @click.native="updateSelectedTab('security')">
                        <q-item-main label="Security" />
                    </q-item>
                    <q-item v-if="mode === 'edit' && $p(['ADMIN','MANAGER'],'or')" :class="{active:selectedTab === 'billing'}" @click.native="updateSelectedTab('billing')">
                        <q-item-main label="Billing" />
                    </q-item>
                    <q-item v-if="mode === 'edit'" :class="{active:selectedTab === 'notifications'}" @click.native="updateSelectedTab('notifications')">
                        <q-item-main label="Notifications" />
                    </q-item>
                    <q-item v-if="isInstructor && mode === 'edit'" :class="{active:selectedTab === 'classes'}" @click.native="updateSelectedTab('classes')">
                        <q-item-main label="Classes" />
                    </q-item>
                    <q-item v-if="isAffiliate && $p(['ADMIN'])" :class="{active:selectedTab === 'managers'}" @click.native="updateSelectedTab('managers')">
                        <q-item-main label="Managers" />
                    </q-item>
                    <q-item :class="{active:selectedTab === 'roles'}" @click.native="updateSelectedTab('roles')" v-if="!$p(['INSTRUCTOR'])">
                        <q-item-main label="Roles" />
                        <q-item-side v-if="validation.instructorForm.$invalid || validation.affiliateForm.$invalid || validation.affiliateForm.$invalid || validation.recruiterForm.$invalid" icon="fa fa-flag" color="red" class="flag-icon"/>
                    </q-item>
                    <q-item v-if="mode === 'edit'" :class="{active:selectedTab === 'notes'}" @click.native="updateSelectedTab('notes')">
                        <q-item-main label="Notes" />
                    </q-item>
                </q-list>
            </div> 
            <div id="class-modal-right" class="sl-col-9 sl-vp" style="padding-bottom:60px;overflow-x:hidden">
              
                <migrate-instructor v-if="migrateOpen" />
                <!-- General -->
                <div v-if="selectedTab === 'general'">
                  <user-details :validation="validation"/>
                </div>
                <!-- Addresses -->
                <div v-if="selectedTab === 'addresses'">
                  <user-addresses :validation="validation"/>
                </div>
                <!-- Documents -->
                <div v-if="selectedTab === 'documents'">
                  <user-documents :validation="validation"/>
                </div>
                <!-- Security -->
                <div v-if="selectedTab === 'security'">
                  <user-security :validation="validation"/>
                </div>
                <div v-if="selectedTab === 'billing'">
                  <user-billing :validation="validation"/>
                </div>
                <!-- Notifications -->
                <div v-if="selectedTab === 'notifications'">
                  <user-notifications :validation="validation"/>
                </div>
                <!-- Classes -->
                <div v-if="selectedTab === 'classes'">
                  <user-classes :validation="validation"/>
                </div>
                <!-- Managers -->
                <div v-if="selectedTab === 'managers'">
                  <user-managers :validation="validation"/>
                </div>
                <!-- Affiliates -->
                <!-- <div v-if="selectedTab === 'managers'">
                  <user-affiliates :validation="validation"/>
                </div> -->
                <!-- Roles -->
                <div v-if="selectedTab === 'roles'">
                  <user-roles :validation="validation"/>
                </div>
                <!-- Notes -->
                <div v-if="selectedTab === 'notes'">
                  <user-notes :validation="validation"/>
                </div>
            </div>
        </div>                  
        <q-toolbar slot="footer" class="sl-footer"> 
          <div v-if="this.mode == 'approve' && this.activeApprovalStatus != 'APPROVED' && this.activeApprovalStatus != 'REJECTED'">
            <q-btn
              label="Approve"
              icon="done"
              color="positive"
              @click.native="submitForApprovalMethod({id:activeApprovalId, status: 2})" />&nbsp;
            <q-btn-dropdown
              label="Reject"
              outline
              icon="clear"
              color="negative">
              <q-list id="rejectionOverlay">
                <q-item>
                  <div class="reject-notes">
                    <q-input
                      stack-label="Rejection Notes*"
                      type="textarea"
                      :value="rejectionNotes"
                      @input="val => updateRejectionNotes(val)"
                    />
                    <q-btn
                      label="Reject"
                      icon="clear"
                      color="negative"
                      @click.native="submitForApprovalMethod({id:activeApprovalId, status: 3})"
                      v-close-overlay
                    />
                    <q-btn
                      label="Cancel"
                      outline
                      v-close-overlay
                    />
                  </div>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div> 
          <q-btn color="primary" 
            outline
            @click.native="submitForApprovalMethod({id:activeApprovalId})"
            :label="submitForApprovalLabel"
            v-show="activeApprovalStatus=='REJECTED'"
            :loading="submitting"
            :disabled="submitting" />   
          <q-btn
            outline
            icon="fa fa-magic"
            color="purple"
            @click.native="onSetMigrateOpen"
            v-if="$p(['ADMIN']) && affiliateForm.ACTIVE_IND"
            >
             &nbsp;Migrate Instructor
          </q-btn>
          {{migrateOpen}}
          <q-toolbar-title> 
          </q-toolbar-title> 
          <div class="q-px-sm" v-if="selectedTab === 'documents'">
            {{canUploadDocuments}}
            <q-btn 
              class="q-px-md" 
              label="Upload" 
              color="green" 
              @click="openUploadModal()"
              :disable="savingUser"
              v-if="canUploadDocuments"
            /> 
          </div> 
          <div class="q-px-sm" v-if="mode === 'edit'" > 
            <q-btn
              class="q-px-md"
              color="green"
              label="Save"
              :disable="validation.$invalid || savingUser"
              @click="onUpdate()"
            /> 
          </div> 
          <div class="q-px-sm" v-if="mode === 'add'" > 
            <q-btn 
              class="q-px-md" 
              color="green" 
              label="Add" 
              :disable="validation.$invalid || savingUser" 
              @click="onAdd()" 
            />&nbsp; 
          </div> 
          <q-btn outline color="faded" @click.native="closeDetails" label="Cancel" :disable="savingUser" /> 
        </q-toolbar> 
      </q-modal-layout>
      <q-inner-loading :visible="savingUser">
          <q-spinner-puff color="primary" size="70"></q-spinner-puff>
          <span>Saving User..</span>
      </q-inner-loading>
    </q-modal>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { hasOne } from 'src/utils/validators'
import { required, requiredIf, requiredUnless, email, minLength, maxLength, numeric, sameAs } from 'vuelidate/lib/validators'
import { isDate } from 'src/utils/validators'
import { notify } from 'src/plugins/notify'
import UserDetails from '../User/UserDetails'
import UserAddresses from '../User/UserAddresses'
import UserDocuments from './UserDocuments'
import UserSecurity from './UserSecurity'
import UserBilling from './UserBilling'
import UserClasses from './UserClasses'
import UserManagers from '../User/UserManagers'
import UserRoles from '../User/UserRoles'
import UserNotes from '../User/UserNotes'
import UserNotifications from '../User/UserNotifications'
import MigrateInstructor from '../User/migrateInstructor'
import { lkKey } from 'src/utils'
const moment = require('moment')

export default {
  name: 'Details',
  components: {
    UserDetails,
    UserAddresses,
    UserDocuments,
    UserSecurity,
    UserClasses,
    UserBilling,
    UserManagers,
    UserRoles,
    UserNotes,
    UserNotifications,
    MigrateInstructor
  },
  created () {
    this.fetchAffiliates()
    this.fetchRecruiters()
    this.fetchManagers()
    this.fetchAdministrators()
    this.maximized = false
  },
  mounted () {
    this.setEditAbility()
  },
  data () {
    return {
      moduleIcon: {
        users: 'user'
      },
      removeDialogOptions: {
        title: 'Remove User',
        message: 'Are you sure you want to remove this user?',
        ok: {
          label: 'Remove',
          color: 'negative'
        },
        cancel: {
          label: 'Cancel',
          color: 'positive'
        }
      },
      saving: false,
      submitting: false,
      moment: moment,
      maximized: false,
      hideEntity: true,
      changePasswordForm: this.$store.state.auth.changePasswordForm
    }
  },
  validations () {
    let vm = this
    return {
      userForm: {
        USER_FIRST_NAME: { required },
        USER_LAST_NAME: { required },
        USER_EMAIL: { required, email },
        USER_DOB: (this.instructorForm.ACTIVE_IND) ? { required, isDate }: { required: false, isDate },
        // USER_SSN_A: (this.instructorForm.ACTIVE_IND) ? { required, minLength: minLength(6), maxLength: maxLength(6) } : { required: false, minLength: minLength(6), maxLength: maxLength(6) },
        // USER_SSN_B:(this.instructorForm.ACTIVE_IND) ? { required, minLength: minLength(4), maxLength: maxLength(4)  } : { required: false, minLength: minLength(4), maxLength: maxLength(4) },
        // USER_SSN_B:(this.instructorForm.ACTIVE_IND) ? { required } : {},
        USER_PHONE: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false }
      },
      billingAddressForm: {
        ADDRESS_1: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
        LK_STATE_ID: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
        ZIP_CODE: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required, minLength: minLength(5), maxLength: maxLength(5) } : { required: false, minLength: minLength(5), maxLength: maxLength(5) },
        CITY: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
        COUNTY: (this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND) ? { required } : { required: false }
      },
      shippingAddressForm: {
        ADDRESS_1: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required} : { required: false },
        LK_STATE_ID: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
        ZIP_CODE: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required, minLength: minLength(5), maxLength: maxLength(5)  } : { required: false, minLength: minLength(5), maxLength: maxLength(5) },
        CITY: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND || this.instructorForm.ACTIVE_IND )) ? { required } : { required: false },
        COUNTY: (!this.sameAsBilling && ( this.affiliateForm.ACTIVE_IND || this.recruiterForm.ACTIVE_IND )) ? { required } : { required: false },
      },
      changePasswordForm: {
        password: { minLength: minLength(6), maxLength: maxLength(20) },
        confirmPassword: { minLength: minLength(6), maxLength: maxLength(20), sameAs: sameAs('password') }
      },
      // NEED THESE DUPLICATE VALIDATIONS
      instructorForm: {
        INSTRUCTOR_CODE: 
        (this.instructorForm.ACTIVE_IND || this.mode == 'approve') && this.$p(['ADMIN', 'MANAGER'], 'or')
          ? { required }
          : { required: false },
        DRIVERS_LICENSE: (this.instructorForm.ACTIVE_IND) ? { required } : { required: false },
        INSTRUCTOR_AFFILIATES: (this.instructorForm.ACTIVE_IND && this.$p(['ADMIN', 'MANAGER','RECRUITER'], 'or')) ? { required, minLength: minLength(1) } : { required: false},
      },
      affiliateForm: {
        AFFILIATE_CODE: (this.affiliateForm.ACTIVE_IND && this.$p(['ADMIN', 'MANAGER'], 'or')) ? { required } : { required: false },
        AFFILIATE_NAME: (this.affiliateForm.ACTIVE_IND) ? { required } : { required: false },
        STUDENT_PROCESSING_FEE: (this.affiliateForm.ACTIVE_IND) ? { required } : { required: false },
        AVAILABLE_CREDITS: { required: false },
        RECRUITER_FEE: (this.affiliateForm.ACTIVE_IND) ? { 
          validateInput(){
            var isFieldValid;
            if(this.affiliateForm.RECRUITER_FEE){
              isFieldValid =  (parseInt(this.affiliateForm.RECRUITER_FEE) <= parseInt(this.affiliateForm.STUDENT_PROCESSING_FEE)) ? true : false
            }
            else { isFieldValid = true }
            return isFieldValid;            
          }
        } : { required: false },
        FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER: { required: false },
        COURSES : (this.affiliateForm.ACTIVE_IND && vm.$p(['ADMIN','MANAGER','RECRUITER'],'or') && vm.mode != 'approve') ? { required, minLength: minLength(1) } : { required: false } 
      },
      recruiterForm: {
        // MANAGER_ID: this.recruiterForm.ACTIVE_IND ? { required } : { required: false },
        RECRUITER_CODE: this.recruiterForm.ACTIVE_IND ? { required } : { required: false },
      },
      managerForm: {},
      administratorForm: {}
    }
  },
  computed: {
    validation () {
      return this.$v
    },
    userSSNFilledOut(){
      let vm = this
      return vm.userForm.USER_SSN_A && vm.userForm.USER_SSN_B
    },
    ...mapState({
      open: state => state.users.userModal.open,
      selectedTab: state => state.users.userModal.selectedTab,
      mode: state => state.users.userModal.mode,
      canEdit: state => state.users.userModal.canEdit,
      rejectionNotes: state => state.approvals.rejectionNotes,
      userId: state => state.users.selectedUser.user.USER_ID,
      migrateOpen: s=> s.users.migrateOpen
    }),
    ...mapState('users', {
      role: (state) => state.role,
      roles: (state) => state.roles,
      isInstructor: (state) => state.instructorForm.ACTIVE_IND,
      isAffiliate: s => s.affiliateForm.ACTIVE_IND,
      userForm: state => state.userForm,
      billingAddressForm: state => state.billingAddressForm,
      shippingAddressForm: state => state.shippingAddressForm,
      sameAsBilling: state => state.shippingAddressForm.sameAsBilling,      
      instructorForm: state => state.instructorForm,
      affiliateForm: state => state.affiliateForm,
      recruiterForm: state => state.recruiterForm,
      activeApprovalId:  state => state.activeApproval.INSTRUCTOR_ID,
      activeApprovalStatus:  state => state.activeApproval.STATUS,
      activeApprovalNotes:  state => state.activeApproval.NOTES,
      activeApprovalHistory:  state => state.activeApproval.history,
      savingUser: s => s.savingUser
    }),
    submitForApprovalLabel () {
      return this.status == 'REJECTED' ? 'Resubmit For Approval' : 'Submit For Approval'
    },
    editUserLabel(){
      let vm = this
      let fullName = vm.userForm.USER_FIRST_NAME + " " + vm.userForm.USER_LAST_NAME
      return fullName.trim() != '' ? `- ${fullName}` : ''
    },
    canUploadDocuments(){
       return (!this.activeApproval || this.activeApprovalStatus == 'REJECTED' || this.mode =='edit') ? true : false
    }
  },
  methods: {
    ...mapActions('users', [
      'add',
      'addNew',
      'fetchUserDetails',
      'select',
      'create',
      'update',
      'remove',
      'fetchAffiliates', 
      'fetchRecruiters',
      'fetchManagers',
      'fetchAdministrators',
      'submitInstructorForApproval',
      'clearAllForms'
    ]),
    ...mapMutations('users', [
      'openUserModal',
      'closeDetails',
      'updateRole',
      'updateSelectedTab',
      'updateEditState',
      'resetSelectedUser',
      'setMigrateOpen'
    ]),
    ...mapMutations('approvals',[
        'updateRejectionNotes'
    ]),
    successHandler (response) {
      this.$v.$reset()
    },
    selectTab (tabName) {
        this.selectedTab = tabName
    },
    onRemove () {
      this.$q.dialog(this.removeDialogOptions)
      .then(this.remove).then(this.successHandler)
    },
    onAddNew () {
      this.addNew().then(this.successHandler)
    },
    onAdd () {
      this.add().then(this.successHandler)
    },
    async onUpdate () {
      try {
        let vm = this
        let canSave = true
        if (vm.validation.changePasswordForm.$dirty){
          if((vm.currentUser().USER_ID == vm.userForm.USER_ID) && vm.changePasswordForm.currentPassword == vm.changePasswordForm.password){
            notify.create({message:'Old and New passwords are the same.', type: 'negative', position: 'top'})
            return 
          }
         let { success } = await vm.$store.dispatch('auth/submitChangePasswordForm', this.userForm)
         if(!success) canSave = false
        }
        if(canSave) await vm.update({vm}).then(vm.successHandler)
      } catch (err) {
        console.log(err)
      }
    },
    openUploadModal () {
      this.$store.dispatch('documents/openUploadModal', 
      { LK_ENTITY_ID: 1, ENTITY_ITEM_ID: this.userForm.USER_ID }, 
      { root: true })
    },
    onClose () {
      this.closeDetails()
      this.resetSelectedUser()
    },
    setEditAbility () {
      if( this.mode == 'approve' ){
        return this.updateEditState(false)
      } else{
        return this.updateEditState(true)
      }
    },
    // Returns either icon or Approval type
    approvalDetail(approval, isIcon){
        if (!approval) return
        let icon
        let approvalStatus = approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID
        if(!isIcon){
            return lkKey('LK_CLASS_APPROVAL_STATUS_ID', approvalStatus)
        }
        switch(approvalStatus){
            case 1: // Submitted
                icon = 'move_to_inbox'
                break
            case 2: // Approved
                icon = 'done'
                break
            case 3: // Rejected
                icon = 'close'
                break
            case 4: // Expired
                icon = 'call_missed'
                break
            case 5: // Resubmitted
                icon = 'redo'
                break
        }
        return icon
    },
    activeApproval () {
        return this.activeApprovalHistory && this.activeApprovalHistory[0]
    },
    async submitForApprovalMethod ({ id, status }) {
      let vm = this
         
      if (status === 3 && !vm.rejectionNotes){
        return notify.create({
          message: 'Please add rejection notes!',
          type: 'negative'
        })
      }

      if(vm.$p(['ADMIN','MANAGER'],'or')){
        if(vm.instructorForm.ACTIVE_IND) {
          vm.$v.instructorForm.$touch()
          if(vm.$v.instructorForm.$invalid) return
        }
        if(vm.affiliateForm.ACTIVE_IND) {
          vm.$v.affiliateForm.$touch()
          if(vm.$v.affiliateForm.$invalid) return
        }
      }
      
      vm.submitting = true
      await vm.update({vm})
        .then(()=>{
          vm.submitInstructorForApproval({
            id:vm.instructorForm.INSTRUCTOR_ID,
            status:status,
            notes:vm.rejectionNotes,
            vm: vm
          })
          .then(vm.successHandler)
        })
      
    },
    toggleMaximized(){
        this.maximized = !this.maximized
    },
    onSetMigrateOpen(){
      this.setMigrateOpen(true)
    }
  }
}

</script>

<style lang="stylus">
  @import '~variables'
  .flag-icon {
    font-size:1.4rem !important
  }
  .details-inner
    position absolute 
    height 100%
    width 100%
    .q-tabs-head
      z-index 2
      background-color lighten(border-color,80%) !important
      .q-tab.active
        border-bottom-color
        .q-tabs-bar 
          border-bottom-color $primary
        .q-tab-label
          color $primary
      .q-tab-label
        color text-color
    .sl-row.sl-abs
      height calc(100% - 60px)
      > .sl-col-12
        position absolute 
        top 50px
    .q-toolbar.sl-footer
      position absolute 
      bottom 0
      background white !important
      border-top 1px solid border-color
  #details-modal.users
    #class-modal-right
      padding 0
</style>
